// Externe Bibliotheken
import React, { Component } from 'react';
import { Link } from 'react-router';
import _ from 'lodash';

// Interne Module
import { convertPrice } from '@/_helper/mapper';
import * as storage from '@/_helper/storage';
import { chipClass } from '@/pages/extra-services/excursion/_helper/mapper';

// Styles
import './serviceToBeBooked.scss';

class ServiceToBeBooked extends Component {
    service(travelType) {
        const { title } = window.$content.extras[travelType];
        const { vacancyData } = this.props.bookStates;

        let $travel = [];

        switch (travelType) {
            case 'excursion':
                const dateValue = () => {
                    let dateValue = vacancyData.startDate.split('T');

                    // full date
                    let date = new Date(dateValue[0]).toLocaleDateString('de-DE', {
                        day: '2-digit',
                        month: 'long',
                        year: 'numeric',
                    });

                    // weekday
                    let weekday = new Date(dateValue[0]).toLocaleDateString('de-DE', { weekday: 'long' });

                    // time
                    let time = '';
                    if (dateValue[1] !== undefined) {
                        time = dateValue[1].slice(0, -3);
                    }

                    return {
                        fullDate: date !== undefined ? date : '',
                        weekday: weekday !== undefined ? weekday : '',
                        time: time !== undefined ? time : '',
                    };
                };

                const parseTime = (value) => {
                    let timeValue = '';
                    if (value !== undefined) {
                        timeValue = value.slice(0, -3);
                    }
                    return timeValue;
                };

                const duration = () => {
                    let duration = vacancyData.duration;
                    if (duration === '0') {
                        duration = '';
                    } else {
                        duration = duration.replaceAll('PT', '');

                        if (parseInt(duration.substring(0, duration.indexOf('H'))) === 1) {
                            duration = duration.replaceAll('H', ' Stunde ');
                        } else {
                            duration = duration.replaceAll('H', ' Stunden ');
                        }

                        if (parseInt(duration.substring(0, duration.indexOf('M'))) === 1) {
                            duration = duration.replaceAll('M', ' Minute ');
                        } else {
                            duration = duration.replaceAll('M', ' Minuten ');
                        }

                        duration += '<span class="text-normal">Dauer </span>';
                        if (vacancyData.transferIncluded) {
                            duration += '<br/><span class="text-normal">(ohne Transferzeit)</span>';
                        }
                    }

                    return (
                        (vacancyData.transferTime || vacancyData.startTime || vacancyData.duration !== '0') && (
                            <div className="e duration flex">
                                <i className="material-icons">schedule</i>
                                <div className="cnt">
                                    {vacancyData.transferTime && (
                                        <div>
                                            <b>{parseTime(vacancyData.transferTime)} Uhr</b>
                                            <br />
                                            Pickup am Hotel
                                        </div>
                                    )}
                                    {vacancyData.startTime && (
                                        <div>
                                            <b>{parseTime(vacancyData.startTime)} Uhr</b> Beginn
                                        </div>
                                    )}
                                    <div>
                                        <b dangerouslySetInnerHTML={{ __html: duration }}></b>
                                    </div>
                                </div>
                            </div>
                        )
                    );
                };

                const paxe = () => {
                    let bookingData = storage.get('bookingData');

                    if (bookingData === undefined || bookingData === null) {
                        return false;
                    }

                    let a = 0,
                        c = 0;

                    this.props.bookStates.travellers.forEach((value) => {
                        if (value === null) {
                            return false;
                        }

                        let age = value.age;
                        if (age !== undefined) {
                            if (age >= 18) {
                                a++;
                            }

                            if (age < 18) {
                                c++;
                            }
                        }
                    });

                    if (a + c === 0) {
                        return false;
                    }

                    return (
                        <div className="e persons flex">
                            <i className="material-icons">person</i>
                            <div className="cnt">
                                {a > 0 && (
                                    <>
                                        {' '}
                                        {a} {a > 1 ? 'Erwachsene' : 'Erwachsener'}
                                    </>
                                )}

                                {c > 0 && (
                                    <>
                                        {' '}
                                        {c} {c > 1 ? 'Kinder' : 'Kind'}
                                    </>
                                )}
                            </div>
                        </div>
                    );
                };

                let distanceToAccommodation =
                    vacancyData.distanceToAccommodation ?? vacancyData.distanceToAccommodation;
                distanceToAccommodation = distanceToAccommodation.toString().replaceAll('.', ',');

                const hasPriceChange = this.props.bookStates.hasPriceChange;

                $travel.push(
                    <div className={'service-to-be-booked ' + travelType} key={''}>
                        <div className="intro-line">
                            <div className="summary-headline">Ausflug</div>
                        </div>
                        <div className="content">
                            <div
                                className="col image"
                                style={{ backgroundImage: 'url(' + vacancyData.images[0] + '' }}></div>

                            <div className="col inline">
                                <div className="main">
                                    <div className="heading extra">{vacancyData.title}</div>

                                    <div className="article">
                                        <div className="line">
                                            <div className="e place">
                                                <i className="material-icons">place</i> {vacancyData.resort}
                                            </div>
                                        </div>
                                        <div className="line">
                                            {distanceToAccommodation && (
                                                <div className="e place">
                                                    {distanceToAccommodation} km vom Hotel entfernt
                                                </div>
                                            )}

                                            {vacancyData.category && (
                                                <div className={`e chip ${chipClass(vacancyData.category)} `}>
                                                    {vacancyData.category}
                                                </div>
                                            )}
                                        </div>

                                        <div className="e date">
                                            <b>{dateValue().fullDate + ' - ' + dateValue().weekday}</b>
                                        </div>

                                        <div className="line details">
                                            {duration()}

                                            {paxe()}
                                        </div>
                                    </div>
                                </div>

                                {vacancyData != null && (
                                    <div className="price-sec">
                                        {vacancyData.pickupDropOffIndicator === 'true' && (
                                            <div className="transport">
                                                inkl. Transport zum Ausflug
                                                {vacancyData.transferDescription !== null &&
                                                    vacancyData.transferDescription.length > 0 && (
                                                        <small className="unit">
                                                            {vacancyData.transferDescription}
                                                        </small>
                                                    )}
                                            </div>
                                        )}

                                        <div className="price">
                                            {vacancyData.price.packagePrice >= 0 ? '+' : '-'}{' '}
                                            {convertPrice(vacancyData.price.packagePrice)}
                                            <div className="price-small-print">(Gesamtpreis für alle Reisenden)</div>
                                            {hasPriceChange && (
                                                <div className="price-small-print price-change">
                                                    Bitte beachten Sie die kurzfristige Preiserhöhung.
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                );
                break;
            case 'transfer':
                function icon(tariffCode) {
                    let icon = 'airport_shuttle';

                    switch (tariffCode) {
                        case (tariffCode = 'taxi'):
                            icon = 'directions_car';
                            break;
                        default:
                    }

                    return icon;
                }

                let subtitle =
                    window.$content.mappingTransfer[vacancyData.tariffCode.toLowerCase()] !== undefined &&
                    window.$content.mappingTransfer[vacancyData.tariffCode.toLowerCase()].heading !== undefined
                        ? window.$content.mappingTransfer[vacancyData.tariffCode.toLowerCase()].heading
                        : vacancyData.tariffCode.charAt(0).toUpperCase() +
                          vacancyData.tariffCode.toLowerCase().slice(1).replace('_', '-');

                $travel.push(
                    <div className={'service-to-be-booked ' + travelType} key={''}>
                        <div className="intro-line">
                            <div className="summary-headline">{title}</div>
                        </div>
                        <div className="content">
                            <div className="col image">
                                <div className="icon">
                                    <i className="main material-symbols-outlined">
                                        {icon(vacancyData.tariffCode.toLowerCase())}
                                    </i>
                                </div>

                                <div className="title extra">{subtitle}</div>
                            </div>

                            <div className="col inline">
                                <div className="main">
                                    <div className="heading extra">
                                        {title} - {subtitle}
                                    </div>

                                    <div className="article">
                                        {window.$content.mappingTransfer[vacancyData.tariffCode.toLowerCase()] !==
                                            undefined &&
                                        window.$content.mappingTransfer[vacancyData.tariffCode.toLowerCase()]
                                            .heading !== undefined
                                            ? window.$content.mappingTransfer[vacancyData.tariffCode.toLowerCase()]
                                                  .description
                                            : vacancyData.tariffCode.charAt(0).toUpperCase() +
                                              vacancyData.tariffCode.toLowerCase().slice(1).replace('_', '-')}
                                    </div>
                                </div>

                                {vacancyData != null && (
                                    <div className="price-sec">
                                        {vacancyData.price.packagePrice >= 0 ? '+' : '-'}{' '}
                                        {convertPrice(vacancyData.price.packagePrice)}
                                        {vacancyData.price.pricePerPerson > 0 ? (
                                            <div className="price-small-print">
                                                {convertPrice(vacancyData.price.pricePerPerson)} p.P.
                                            </div>
                                        ) : (
                                            <div className="price-small-print">(Gesamtpreis für alle Reisenden)</div>
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                );
                break;
            case 'railAndFly':
                let titleMapper = {
                    both: 'Roundtrip',
                    inbound: 'einfache Rückfahrt',
                    outbound: 'einfache Hinfahrt',
                };

                let directionIcon = '';

                switch (vacancyData.direction) {
                    case (vacancyData.direction = 'both'):
                        directionIcon = 'autorenew';
                        break;
                    case (vacancyData.direction = 'inbound'):
                        directionIcon = 'arrow_back';
                        break;
                    case (vacancyData.direction = 'outbound'):
                        directionIcon = 'arrow_forward';
                        break;
                    default:
                }

                $travel.push(
                    <div className={'service-to-be-booked ' + travelType} key={''}>
                        <div className="intro-line">
                            <div className="summary-headline">{title}</div>
                        </div>
                        <div className="content">
                            <div className="col image">
                                <div className="icon">
                                    <span className="direction">
                                        <i className="material-icons">{directionIcon}</i>
                                    </span>
                                    <i className="main material-symbols-outlined">train</i>
                                </div>

                                <div className="title extra">{titleMapper[vacancyData.direction]}</div>
                            </div>
                            <div className="col inline">
                                <div className="main">
                                    <div className="heading extra">
                                        {title} - {titleMapper[vacancyData.direction]}
                                    </div>

                                    <div
                                        className="article"
                                        dangerouslySetInnerHTML={{ __html: vacancyData.remarks.legalInfo }}></div>
                                </div>

                                {vacancyData != null && (
                                    <div className="price-sec">
                                        {vacancyData.price.packagePrice >= 0 ? '+' : '-'}{' '}
                                        {convertPrice(vacancyData.price.packagePrice)}
                                        {vacancyData.price.pricePerPerson > 0 ? (
                                            <div className="price-small-print">
                                                {convertPrice(vacancyData.price.pricePerPerson)} p.P.
                                            </div>
                                        ) : (
                                            <div className="price-small-print">(Gesamtpreis für alle Reisenden)</div>
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                );
                break;
            case 'seatReservation':
                let { legData, participantsData } = this.props.bookStates;

                let legs = [];

                Object.keys(legData).forEach((value, index) => {
                    let { surcharge } = legData[value];

                    // error handling
                    let legError = [];

                    // participant data
                    let adults = [];
                    let childs = [];

                    let tmpl = (i, v, index, seatError = false) =>
                        !(
                            participantsData[v].seat[index].booked !== undefined &&
                            participantsData[v].seat[index].booked
                        ) && (
                            <div className="entry" key={i}>
                                <div className="cnt">
                                    <div className="name">
                                        <span className="surname">{participantsData[v].forename}</span>{' '}
                                        <span className="lastname">{participantsData[v].surname}</span>
                                    </div>
                                </div>
                                <div className={`seat-cnt ${seatError ? 'seat-error' : ''}`}>
                                    {participantsData[v].seat[index]?.number !== undefined && (
                                        <div className="number">
                                            {participantsData[v].seat[index].number}
                                            {participantsData[v].seat[index].cat !== undefined && (
                                                <small>({participantsData[v].seat[index].cat.name})</small>
                                            )}
                                        </div>
                                    )}
                                    {!seatError && participantsData[v].seat[index]?.price !== undefined && (
                                        <div className="price">
                                            + {participantsData[v].seat[index].price.toString().replaceAll('.', ',')} €
                                        </div>
                                    )}
                                </div>
                            </div>
                        );

                    Object.keys(participantsData).forEach((v, i) => {
                        // error :leg
                        if (
                            this.props.bookStates.error?.offerKeys.includes(participantsData[v].seat[index]?.offerKey)
                        ) {
                            legError.push(index);
                        }

                        // error :seat
                        let seatError = false;
                        if (this.props.bookStates.error !== undefined && this.props.bookStates.error?.offerKeys) {
                            seatError = this.props.bookStates.error?.offerKeys.includes(
                                participantsData[v].seat[index]?.offerKey
                            );
                        }

                        // tmpl handling
                        if (
                            participantsData[v].seat[value] !== undefined &&
                            Object.keys(participantsData[v].seat[value]).length > 0
                        ) {
                            if (participantsData[v].participantType === 'adult') {
                                adults.push(tmpl(i, v, value, seatError));
                            }
                            if (participantsData[v].participantType === 'child') {
                                childs.push(tmpl(i, v, value, seatError));
                            }
                        }
                    });

                    if (!legData[value].allParticipantsBooked) {
                        legs.push(
                            <div
                                className={`service-to-be-booked sec ${travelType} ${
                                    legError.includes(index) ? 'leg-error' : ''
                                } ${legData[value].booked ? 'booked' : ''}`}
                                key={index}>
                                <div className="intro-line">
                                    <div className="summary-headline">
                                        <img
                                            className="carrier-logo"
                                            src="//www.aurumtours.de/img/airline/70/XQ.png"
                                            alt=""
                                        />
                                        {legData[value].title}
                                        <div className="connection-line">
                                            <span>
                                                {legData[value].transportInfo.departure.airport.replace(
                                                    'Flughafen',
                                                    ''
                                                )}
                                            </span>{' '}
                                            ({legData[value].transportInfo.departure.airportCode}) -{' '}
                                            <span>
                                                {legData[value].transportInfo.arrival.airport.replace('Flughafen', '')}
                                            </span>{' '}
                                            ({legData[value].transportInfo.arrival.airportCode})
                                        </div>
                                    </div>
                                </div>
                                <div className="content">
                                    <div className="col inline">
                                        <div className="main">
                                            <div className="participants">
                                                {_.filter(adults, function (o) {
                                                    return o !== false && o;
                                                }).length > 0 && (
                                                    <div className="e">
                                                        <div className="top-line">
                                                            <h3 className="title">Erwachsene</h3>
                                                            <h3 className="title">
                                                                <i className="material-icons">
                                                                    airline_seat_recline_normal
                                                                </i>{' '}
                                                                Sitzplatz
                                                            </h3>
                                                        </div>
                                                        <div className="cnt">{adults}</div>
                                                    </div>
                                                )}

                                                {_.filter(childs, function (o) {
                                                    return o !== false && o;
                                                }).length > 0 && (
                                                    <div className="e">
                                                        <div className="top-line">
                                                            <h3 className="title">Kinder</h3>
                                                            <h3 className="title">
                                                                <i className="material-icons">
                                                                    airline_seat_recline_normal
                                                                </i>{' '}
                                                                Sitzplatz
                                                            </h3>
                                                        </div>
                                                        <div className="cnt">{childs}</div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>

                                        {vacancyData != null && (
                                            <div className="price-sec">
                                                {surcharge >= 0 ? '+' : '-'} {convertPrice(surcharge)}
                                                <div className="price-small-print">
                                                    (Gesamtpreis für alle Reisenden)
                                                </div>
                                                {legError.includes(index) && (
                                                    <Link
                                                        to="/sitzplatzreservierung"
                                                        className="button select-new-seats">
                                                        Neue Plätze wählen
                                                    </Link>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        );
                    }
                });

                $travel = legs;

                break;
            default:
                $travel.push(
                    <div className={'service-to-be-booked ' + travelType} key={''}>
                        <div className="intro-line">
                            <div className="summary-headline">{title}</div>
                        </div>
                        <div className="content">
                            <div
                                className="col image"
                                style={{ backgroundImage: 'url(/img/' + travelType + '-title.jpg)' }}></div>
                            <div className="col inline">
                                <div className="main">
                                    <div className="heading extra">{title}</div>

                                    {vacancyData != null && vacancyData.serviceFullDescription && (
                                        <div className="article">{vacancyData.serviceFullDescription}</div>
                                    )}

                                    {vacancyData != null && vacancyData.description && (
                                        <div className="article">{vacancyData.description}</div>
                                    )}
                                </div>

                                {vacancyData != null && (
                                    <div className="price-sec">
                                        {convertPrice(vacancyData.price.overallGrossPrice)}

                                        {vacancyData.price.pricePerPerson > 0 && (
                                            <small>( {convertPrice(vacancyData.price.pricePerPerson)} p.P.</small>
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                );
        }
        return $travel;
    }

    render() {
        return (
            <div className={`sec active ${'sec-main-' + this.props.travelType}`} key={''}>
                {this.service(this.props.travelType)}
            </div>
        );
    }
}

export default ServiceToBeBooked;
